import { render } from "./statusIcon01.vue?vue&type=template&id=6f6b7e39"
import script from "./statusIcon01.vue?vue&type=script&lang=js"
export * from "./statusIcon01.vue?vue&type=script&lang=js"

import "./statusIcon01.vue?vue&type=style&index=0&id=6f6b7e39&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__